import '../../styles/base.less';
import '../../badge/style/index.less';
import '../../icon/style/index.less';
import '../../cell/style/index.less';
import '../../loading/style/index.less';
import '../../button/style/index.less';
import '../../action-bar/style/index.less';
import '../../overlay/style/index.less';
import '../../popup/style/index.less';
import '../../dialog/style/index.less';
import '../../field/style/index.less';
import '../../lazyload/style/index.less';
import '../../image/style/index.less';
import '../../image-preview/style/index.less';
import '../../uploader/style/index.less';
import './index.less';